module.exports = __webpack_public_path__ + "static/media/img-09.fca8bd92.png";